import { React, useState } from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import { GetBarrierList, EditBarrier } from "../../../Services/barrier";
import { useDispatch } from "react-redux";
import Loader from "../../../Global/loader";
import Switch from "react-switch";

const Edit = (data) => {
    const [loading, setLoading] = useState(true);
    const [validated, setValidated] = useState(false);
    const [show, setShow] = useState(false);
    const dispatch = useDispatch();

    const [id, setId] = useState(0);
    const [name, setName] = useState("");
    const [parklioId, setParklioId] = useState("");
    const [note, setNote] = useState(" ");
    const [enabled, setEnabled] = useState(false);

    const handleShow = async () => {
        setLoading(true);
        setId(data.data.id);
        setName(data.data.name);
        setParklioId(data.data.parklioId);
        setNote(data.data.note);
        setEnabled(data.data.enabled);

        setLoading(false);
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
    };

    const handleSubmit = async (event) => {
        await setLoading(true);
        event.preventDefault();
        setValidated(true);

        try {
            let isSuccess = await EditBarrier(dispatch, id, {
                id,
                name,
                parklioId,
                note,
                enabled,
                locationId: data.data.location.id,
            });
            if (isSuccess) {
                await setShow(false);
                await setValidated(false);
                await GetBarrierList(dispatch);
            }
        } catch {}

        await setLoading(false);
    };

    return (
        <>
            <Button
                variant="flat"
                className="btn"
                bsPrefix="edit"
                onClick={handleShow}
            >
                Promijeni
            </Button>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                className="add-modal"
                centered
                size="lg"
            >
                {!loading ? (
                    <>
                        <Modal.Header closeButton>
                            <Modal.Title>Izmjeni Operatera</Modal.Title>
                        </Modal.Header>

                        <Form
                            noValidate
                            validated={validated}
                            onSubmit={handleSubmit}
                        >
                            <Modal.Body>
                                <div className="operators_container">
                                    <Row style={{ justifyContent: "center" }}>
                                        <Col sm={12}>
                                            <Form.Group
                                                as={Row}
                                                className="mb-3"
                                                controlId="fromLocationName"
                                            >
                                                <Form.Label column sm="4">
                                                    NAZIV
                                                </Form.Label>
                                                <Col sm="8">
                                                    <Form.Control
                                                        type="text"
                                                        defaultValue={name}
                                                        onChange={(e) =>
                                                            setName(
                                                                e.target.value
                                                            )
                                                        }
                                                        required
                                                    />
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="input-error"
                                                    >
                                                        Ime ne smije biti
                                                        prazno!
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>

                                            <Form.Group
                                                as={Row}
                                                className="mb-3"
                                                controlId="formLocationEmail"
                                            >
                                                <Form.Label column sm="4">
                                                    UUID
                                                </Form.Label>
                                                <Col sm="8">
                                                    <Form.Control
                                                        type="text"
                                                        disabled
                                                        defaultValue={parklioId}
                                                        onChange={(e) =>
                                                            setParklioId(
                                                                e.target.value
                                                            )
                                                        }
                                                        required
                                                    />
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="input-error"
                                                    >
                                                        Adresa ne smije biti
                                                        prazna!
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>

                                            <Form.Group
                                                as={Row}
                                                className="mb-3"
                                                controlId="formLocationCity"
                                            >
                                                <Form.Label column sm="4">
                                                    NAPOMENA
                                                </Form.Label>
                                                <Col sm="8">
                                                    <Form.Control
                                                        as="textarea"
                                                        defaultValue={note}
                                                        onChange={(e) =>
                                                            setNote(
                                                                e.target.value
                                                            )
                                                        }
                                                        required
                                                    />
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="input-error"
                                                    >
                                                        Grad ne smije biti
                                                        prazan!
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>

                                            <Form.Group
                                                as={Row}
                                                className="mb-3"
                                                controlId="formLocationCity"
                                            >
                                                <Form.Label column sm="4">
                                                    STATUS
                                                </Form.Label>
                                                <Col sm="8">
                                                    <Switch
                                                        onChange={(e) =>
                                                            setEnabled(e)
                                                        }
                                                        checked={enabled}
                                                        handleDiameter={20}
                                                    />
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="input-error"
                                                    >
                                                        Grad ne smije biti
                                                        prazan!
                                                    </Form.Control.Feedback>
                                                </Col>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                            </Modal.Body>

                            <Modal.Footer>
                                <Button
                                    variant="flat"
                                    className="btn"
                                    bsPrefix="edit"
                                    type="submit"
                                >
                                    Spremi
                                </Button>
                                <Button
                                    variant="flat"
                                    className="btn"
                                    bsPrefix="delete"
                                    onClick={handleClose}
                                >
                                    Otkaži
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </>
                ) : (
                    <div className="loader-container ">
                        <Loader />
                    </div>
                )}
            </Modal>
        </>
    );
};

export default Edit;
